import { IPlace, PlaceEntity } from "./types";

/**
 * Place entity schema convert to model
 */
export function mapPlaceFromEntity(entity: PlaceEntity): IPlace {
    return {
        id: entity.id,
        key: entity.key,
        title: entity.title,
        description: entity.description,
        eventDetailTitle: entity.eventDetailTitle,
        content: entity.content,
        order: entity.order || 0,
        placeSvg: entity.placeSvg,
        profileImageHero: entity.profileImageHero,
        profileImageVertical: entity.profileImageVertical,
        profileImageHorizontal: entity.profileImageHorizontal,
        language: entity.language || "tr",
        relationId: entity.languageRelationId,
        createdBy: entity.createdBy,
        updatedBy: entity.modifiedBy,
        createdAt: entity.createdOn || entity.CreatedOn,
        updatedAt: entity.modifiedOn || entity.ModifiedOn
    }
}

/**
 * Place model schema convert to entity
 */
export function mapPlaceFromModel(model: IPlace): PlaceEntity {
    return {
        id: model.id,
        key: model.key,
        title: model.title,
        eventDetailTitle: model.eventDetailTitle,
        description: model.description,
        content: model.content,
        order: model.order || 0,
        placeSvg: model.placeSvg,
        profileImageHero: model.profileImageHero,
        profileImageVertical: model.profileImageVertical,
        profileImageHorizontal: model.profileImageHorizontal,
        language: model.language || "tr",
        languageRelationId: model.relationId || undefined
    }
}

